var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { default as React } from 'react';
import { StyledMedicationDecisionSupportWarningIcon } from '../Components/Icons';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { dangerVariant, iconLight, primary, successVariant, warningGlowBorder } from '../Styles/Colours';
import styles from './HistorySummaryTable.module.css';
export var HistorySummaryStatusColour;
(function (HistorySummaryStatusColour) {
    HistorySummaryStatusColour[HistorySummaryStatusColour["Yellow"] = 0] = "Yellow";
    HistorySummaryStatusColour[HistorySummaryStatusColour["Red"] = 1] = "Red";
    HistorySummaryStatusColour[HistorySummaryStatusColour["Green"] = 2] = "Green";
    HistorySummaryStatusColour[HistorySummaryStatusColour["Grey"] = 3] = "Grey";
    HistorySummaryStatusColour[HistorySummaryStatusColour["Blue"] = 4] = "Blue";
})(HistorySummaryStatusColour || (HistorySummaryStatusColour = {}));
var HistoryStatus = function (props) {
    var Icon = props.statusIcon;
    var iconProps = {
        size: '16'
    };
    if (props.updatedStatus) {
        iconProps.color = warningGlowBorder;
        Icon = StyledMedicationDecisionSupportWarningIcon;
    }
    else if (props.statusColour === HistorySummaryStatusColour.Grey) {
        iconProps.color = iconLight;
    }
    else if (props.statusColour === HistorySummaryStatusColour.Green) {
        iconProps.color = successVariant;
    }
    else if (props.statusColour === HistorySummaryStatusColour.Red) {
        iconProps.color = dangerVariant;
    }
    else if (props.statusColour === HistorySummaryStatusColour.Blue) {
        iconProps.color = primary;
    }
    return Icon ? (React.createElement("div", { className: styles.historyStatusChip },
        React.createElement("span", { className: styles.historyStatusIcon }, React.createElement(Icon, __assign({}, iconProps))),
        props.statusText)) : (React.createElement("div", { className: styles.historyStatusChip }, props.statusText));
};
var HistoryReason = function (props) {
    var _a, _b, _c;
    var newClasses = classNames(styles.historyValue, styles.newTextValue);
    var oldClasses = classNames(styles.historyValue, styles.oldTextValue);
    return props.updatedStatus ? (React.createElement("div", { className: styles.historyReasonContainer },
        props.newValue !== '' && props.newValue !== null && (React.createElement("div", { className: newClasses },
            React.createElement(Tooltip, { title: (_a = props.newValue) !== null && _a !== void 0 ? _a : '' },
                React.createElement("span", null, props.newValue)))),
        props.oldValue !== '' && props.oldValue !== null && (React.createElement("div", { className: oldClasses },
            React.createElement(Tooltip, { title: (_b = props.oldValue) !== null && _b !== void 0 ? _b : '' },
                React.createElement("span", null, props.oldValue)))))) : (React.createElement("div", { className: styles.historyReasonContainer },
        React.createElement(Tooltip, { title: (_c = props.newValue) !== null && _c !== void 0 ? _c : '' },
            React.createElement("span", null, props.newValue))));
};
export var HistorySummaryTable = function (props) {
    var history = props.historyItems === null
        ? []
        : props.historyItems.map(function (x, index) {
            var _a;
            var _b;
            var backgroundClasses = classNames(styles.container, (_a = {},
                _a[styles.yellowContainer] = x.statusColour === HistorySummaryStatusColour.Yellow,
                _a[styles.redContainer] = x.statusColour === HistorySummaryStatusColour.Red,
                _a[styles.greenContainer] = x.statusColour === HistorySummaryStatusColour.Green,
                _a[styles.greyContainer] = x.statusColour === HistorySummaryStatusColour.Grey,
                _a[styles.blueContainer] = x.statusColour === HistorySummaryStatusColour.Blue,
                _a));
            return (React.createElement("tr", { key: index },
                React.createElement("td", null,
                    React.createElement("div", { className: backgroundClasses },
                        React.createElement("div", { className: styles.statusText },
                            React.createElement(HistoryStatus, { updatedStatus: x.updatedStatus, statusText: x.statusText, statusColour: x.statusColour, statusIcon: x.statusIcon })))),
                React.createElement("td", null,
                    React.createElement("div", { className: styles.changedOnText }, moment(x.changedOn, [
                        ValidDateFormats.NodeDateTimeIso,
                        ValidDateFormats.NodeDateTimeTimezone
                    ]).format(ValidDateFormats.PrettyPrintFullDateTimeWithBullet))),
                React.createElement("td", { className: styles.changedByText },
                    React.createElement(Tooltip, { title: (_b = x.changedBy) !== null && _b !== void 0 ? _b : '' },
                        React.createElement("span", null, x.changedBy))),
                React.createElement("td", null, x.source),
                React.createElement("td", null,
                    React.createElement(HistoryReason, { updatedStatus: x.updatedStatus, newValue: x.newValue, oldValue: x.oldValue }))));
        });
    return (React.createElement("table", { className: styles.history },
        React.createElement("colgroup", null,
            React.createElement("col", { span: 1, style: { width: 160 } }),
            React.createElement("col", { span: 1, style: { width: 180 } }),
            React.createElement("col", { span: 1, style: { width: 260 } }),
            React.createElement("col", { span: 1, style: { width: 180 } }),
            React.createElement("col", { span: 1, style: { minWidth: 400 } })),
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Status"),
                React.createElement("th", null, "Changed on"),
                React.createElement("th", null, "Changed by"),
                React.createElement("th", null, "Source"),
                React.createElement("th", null, "Description"))),
        React.createElement("tbody", null, history)));
};
